import * as angular from "angular";
import * as _ from "lodash";
import EditBatchFormulaUsageName, {openEditBatchFormulaUsage} from "./editBatchFormulaUsage.controller";
import {States} from "../../shared/config/constant.module";
import template from './batchFormulaUsages.tpl.html';
import {Plant} from "../../models/navigation";
import {apsCommon} from "../../shared/dto/aps.common";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import BatchFormulasServiceName, {BatchFormulasService} from "../../services/batches/batchFormulas.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import DateUtilityService from "../../services/utility/dateutility.service";

let requires = [EditBatchFormulaUsageName, LoaderServiceName, NotifyServiceName, BatchFormulasServiceName,
  AuthDataServiceName, UIUtilityServiceName, NavigationServiceName];

interface BatchFormulaUsagesController {
  batchFormulas: apsViewModels.BatchFormulaItem[];
  usages: apsViewModels.BatchFormulaUsageItem[];
  plants: Plant[];
  selectedPlant: Plant;
  tanks: apsCommon.IdAndName[];
  selectedTank: apsCommon.IdAndName;
  plantChanged(): void;
  tankChanged(): void;
  add(): void;
  edit(instance: apsViewModels.BatchFormulaUsageItem): void;
  remove(instance: apsViewModels.BatchFormulaUsageItem): void;
  displayDate(date: Date): string;
}

class BatchFormulaUsagesCtrl implements BatchFormulaUsagesController {
  batchFormulas: apsViewModels.BatchFormulaItem[];
  usages: apsViewModels.BatchFormulaUsageItem[];
  plants: Plant[];
  selectedPlant: Plant;
  tanks: apsCommon.IdAndName[];
  selectedTank: apsCommon.IdAndName;

  private loaderService: LoaderService;
  private batchFormulasService: BatchFormulasService;
  private uiUtilityService: UIUtilityService;
  private notifyService: NotifyService;
  private $modal: mm.foundation.modal;
  private $q: angular.IQService;

  constructor(
    loaderService: LoaderService,
    batchFormulasService: BatchFormulasService,
    $q: angular.IQService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    uiUtilityService: UIUtilityService,
    notifyService: NotifyService,
    $modal: mm.foundation.modal
  ) {
    this.loaderService = loaderService;
    this.batchFormulasService = batchFormulasService;
    this.uiUtilityService = uiUtilityService;
    this.notifyService = notifyService;
    this.$modal = $modal;
    this.$q = $q;

    let promises = [];
    promises.push(navigationService.getNavigation().then(nav => {
      let plants = nav.plants();
      this.plants = _.filter(plants, (plant: Plant) => {
        return authDataService.isAPSIOAdminForPlant(plant.id);
      });

      if (nav.selectedPlant && _.includes(this.plants, nav.selectedPlant)) {
        this.selectedPlant = nav.selectedPlant;
      } else {
        this.selectedPlant = _.first(this.plants);
      }

      return this.plantChangedPrivate();
    }));

    this.loaderService.loadingPromise(this.$q.all(promises));
  }

  displayDate(date: Date): string {
    return DateUtilityService.formatDate(date, this.selectedPlant ? this.selectedPlant.timeZoneId : null);
  }

  private plantChangedPrivate(): angular.IPromise<any> {
    this.tanks = this.selectedPlant.tanks;
    this.selectedTank = _.first(this.tanks);

    let promises = [];

    promises.push(this.batchFormulasService
      .get(this.selectedPlant.id)
      .then(batchFormulas => this.batchFormulas = batchFormulas));          

    promises.push(this.tankChangedPrivate());

    return this.$q.all(promises);
  }

  private tankChangedPrivate(): angular.IPromise<any> {
    return this.batchFormulasService
      .getUsages(this.selectedPlant.id, this.selectedTank.id)
      .then(usages => this.usages = usages);
  }

  plantChanged(): void {
    this.loaderService.loadingPromise(this.plantChangedPrivate());
  }

  tankChanged(): void {
    this.loaderService.loadingPromise(this.tankChangedPrivate());
  }

  add(): void {
    let result = openEditBatchFormulaUsage({
      plant: this.selectedPlant,
      tank: this.selectedTank,
      batchFormulas: this.batchFormulas
    }, this.$modal);

    result.then(instance => {
      if (!instance) {
        return;
      }

      this.usages.push(instance);
    });
  }

  edit(instance: apsViewModels.BatchFormulaUsageItem): void {
    let result = openEditBatchFormulaUsage({
      instance: instance,
      plant: this.selectedPlant,
      tank: this.selectedTank,
      batchFormulas: this.batchFormulas
    }, this.$modal);

    result.then(updated => {
      if (!updated) {
        return;
      }

      _.remove(this.usages, instance);
      this.usages.push(updated);
    });
  }

  remove(instance: apsViewModels.BatchFormulaUsageItem): void {
    this.uiUtilityService.confirm('Are you sure you want to delete this Formula Usage?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      this.loaderService.loadingPromise(this.batchFormulasService.removeUsage({
        id: instance.id
      }).then(() => {
        _.remove(this.usages, instance);
      }, this.notifyService.handleApiErrors));
    });
  }
}

export default angular.module('aps.controller.batchFormulaUsages', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.BATCH_FORMULA_USAGES,
      url: '/admin/batchFormulaUsages',
      controller: 'BatchFormulaUsagesCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Batch Formula Usages',
        authorizeAPSIOAdmin: true
      }
    });
  })
  .controller('BatchFormulaUsagesCtrl', BatchFormulaUsagesCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/batchFormulaUsages.controller.ts